"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _once = _interopRequireDefault(require("../../utils/once"));

var _ViewportManager = _interopRequireDefault(require("./ViewportManager"));

var _theme = require("@vds-core/theme");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var propTypes = {
  /**
   * If provided, the given value will be the max-width of the mobile viewport.
   */
  maxMobile: _propTypes["default"].string,

  /**
   * If provided, the given value will be the max-width of the tablet viewport.
   */
  maxTablet: _propTypes["default"].string
};
var defaultProps = {
  maxMobile: _theme.breakpoints.md,
  maxTablet: _theme.breakpoints.lg
};
/**
 * This is the root class to manage a variety of things for applications utilizing VDS.
 * A user will implement this class as a Wrapper around their application once.
 */

var VDSManager = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(VDSManager, _React$Component);

  var _super = _createSuper(VDSManager);

  function VDSManager(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, VDSManager);
    _this = _super.call(this, props);

    _ViewportManager["default"].register(_this.props);

    return _this;
  }

  (0, _createClass2["default"])(VDSManager, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _ViewportManager["default"].unregister(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.children) {
        return null;
      }

      return this.props.children;
    }
  }]);
  return VDSManager;
}(_react["default"].Component);

VDSManager.defaultProps = defaultProps;
VDSManager.propTypes = propTypes;
var _default = VDSManager;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/~/@vds-core/utilities/dist/cjs/components/AppManager/Manager.js
// module id = 1443
// module chunks = 0